import { Spinner } from '@creditornot/cb-ingredients';
import React from 'react';

import { TaxReportingInfoModal } from './TaxReportingInfoModal';
import { TokenAlert } from './TokenAlert';
import { useTokenStatus } from './hooks/useTokenStatus';
import { TokenStatus } from './utils';
import { APIErrorNotification } from '../../common/components';

export const TaxReportingAlert = ({
  merchantId,
  country,
  isRoot,
}: {
  merchantId: string;
  country: string;
  isRoot: boolean;
}) => {
  const [showMoreInfo, setShowMoreInfo] = React.useState(false);

  const { status, daysAfterTokenExpires, loading, error } = useTokenStatus(merchantId, country);

  if (status === TokenStatus.INFO && country !== 'ISR') {
    return null;
  }

  const handleModalClose = () => {
    setShowMoreInfo(false);
  };

  const handleModalOpen = () => {
    setShowMoreInfo(true);
  };

  if (loading) {
    return <Spinner data-testid="spinner" size="large" />;
  }

  /**
   * If the status code of error is 404 then it's assumed that the user has not logged in yet and doesn't have a token.

   * In this case instead of showing the error message we show the initial message and ask them to login.
   */

  if (error && status !== TokenStatus.INITIAL) {
    return <APIErrorNotification data-testid="error-container" error={error} />;
  }

  if (isRoot && status === TokenStatus.INFO) {
    return null;
  }

  return (
    <>
      {!!status && (
        <TokenAlert
          status={status}
          merchantId={merchantId}
          daysAfterTokenExpires={daysAfterTokenExpires}
          handleModalOpen={handleModalOpen}
        />
      )}
      {showMoreInfo && <TaxReportingInfoModal merchantId={merchantId} onClose={handleModalClose} />}
    </>
  );
};
